import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useState, useEffect } from "react";
import CalendarGridDailyVisit from "../calender-grid/CalenderGridDailyVisit";
import { RegionType } from "../../../../../domain/models/daily-visit-report/dailyVisitReport";
import AreaWiseDailyVisit from "./AreaWiseDailyVisitReport";
import { displayPartsToString } from "typescript";

type Props = {
  data: RegionType;
  month: number;
  year: number;
  downloadJson: any[];
  customerTypeId: string | null;
};

const RegionWiseDailyVisit: React.FC<Props> = ({
  data,
  month,
  year,
  downloadJson,
  customerTypeId,
}) => {
  const columns = [
    { field: "User" },
    { field: "Territory" },
    { field: "Status" },
  ];
  const daysInMonth = new Date(year, month, 0).getDate();
  const [totalAll, setTotalAll] = useState<number[]>(
    new Array(daysInMonth).fill(0)
  );
  const [totalRow, setTotalRow] = useState<JSX.Element[]>([]);
  const [total, setTotal] = useState<number>(0);

  useEffect(() => {
    setTotalAll(new Array(daysInMonth).fill(0));
  }, [month, year]);

  const regionJSON: any = {};
  useEffect(() => {
    let total = 0;
    for (const item of totalAll) {
      if (typeof item === "number") {
        total += item;
      } else if (item === "H") {
        total += 0;
      }
    }
    setTotal(total);
    regionJSON.role = "RBM";
    regionJSON.user = data.rbm_name;
    regionJSON.territory = data.region_name;
    regionJSON.total = total;
    totalAll.forEach((total, index) => {
      const dayPropertyName = `${index + 1}`;
      regionJSON[dayPropertyName] = total;
    });
    const getDayOfWeek = (day: number) => {
      return new Date(year, month - 1, day).getDay();
    };
    const totalRowCells = totalAll.map((total, index) => {
      const isSunday = getDayOfWeek(index + 1) === 0;
      return (
        <TableCell
          key={index}
          align="center"
          sx={{
            border: "2px solid white",
            padding: 0,
            width: 30,
            fontSize: 12,
            backgroundColor: "#cfeafc",
          }}
        >
          {isSunday ? "H" : total}
        </TableCell>
      );
    });
    setTotalRow(totalRowCells);

    const existingIndex = downloadJson.findIndex(
      (item) => item.user === regionJSON.user
    );
    if (existingIndex !== -1) {
      downloadJson[existingIndex] = regionJSON;
    } else {
      downloadJson.push(regionJSON);
    }
  }, [totalAll, month, year]);

  return (
    <>
      <TableContainer
        sx={{
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
          borderRadius: "10px",
          border: "2px solid white",
          maxWidth: 1500,
        }}
      >
        <Table sx={{ minWidth: "100%", tableLayout: "auto" }}>
          <TableHead>
            <TableRow>
              <CalendarGridDailyVisit
                columns={columns}
                year={year}
                month={month}
              />
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell
                padding="none"
                sx={{
                  border: "2px solid white",
                  width: 80,
                  padding: 0,
                  fontSize: 12,
                  fontWeight: 550,
                }}
                colSpan={4}
              ></TableCell>
              <TableCell
                sx={{
                  border: "2px solid white",
                  padding: 0,
                  textAlign: "center",
                  width: 80,
                  fontSize: 12,
                }}
              >
                {total}
              </TableCell>
              {totalRow}
            </TableRow>
            {data.areas.map((area) => (
              <AreaWiseDailyVisit
                data={area}
                month={month}
                year={year}
                totalRegion={totalAll}
                downloadJson={downloadJson}
                customerTypeId={customerTypeId}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default RegionWiseDailyVisit;
